<template>
    <el-card>
        <Headerss slot="header"></Headerss>
        <Contents :getCartProducts="getCartProducts"></Contents>
        <!--<Footer-->
            <!--:cartProducts="cartProducts"-->
            <!--:getCartProducts="getCartProducts"-->
        <!--&gt;</Footer>-->
    </el-card>
</template>
<script>
    // import Vue from 'vue';
    import Headerss from '../components/GoodsSetups/Headers';
    import Contents from '../components/GoodsSetups/Content';
    import {getCartProducts} from '../stores/api';

    // Vue.component('Header');
    // Vue.component('Content', GoodsSetup.Content);
    // Vue.component('Footer', GoodsSetup.Footer);

    export default {
        components:{
            Headerss,
            Contents
        },
        data () {
            return {
                cartProducts: [],
            };
        },
        beforeMount() {
            this.getCartProducts();
        },
        methods: {
            async getCartProducts() {
                getCartProducts().then(res => {
                    this.cartProducts = res.data.goods_list;
                });
            }
        },
    };
</script>

<style lang="less" scoped>
    /deep/ .el-card__header {
        padding: 10px 40px;
    }
    /deep/ .el-card__body {
        padding: 30px 40px;

    }
</style>



// WEBPACK FOOTER //
// src/router/GoodsSetups.vue